@if (advantageId) {
  <div class="dip-card-container">
    <div class="header">
      <div class="icon-bg">
        <div class="icon-container">
          <svg-icon
            [src]="mappedIcons[advantageId] ?? unknownTypeIconPath"
            [svgStyle]="{ 'width.px':50 }"
            data-cy="dip-dynamic-icon"
            [attr.data-cy-src]="mappedIcons[advantageId] ?? unknownTypeIconPath"
          ></svg-icon>
        </div>
      </div>
      <div class="name">
        {{ 'aboutDip.dipAdvantages.' + advantageId + '.header' | translate }}
      </div>
    </div>
    <p class="description">
      {{ 'aboutDip.dipAdvantages.' + advantageId + '.desc' | translate }}
    </p>
  </div>
}